//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/Builder.js";
import "../no/ErrorList.js";
let d=[[],[[["numberOfAttributeGroups"],"GetRevisedAttributeGroups",{R_:{attributeGroups:"PDM.AttributeGroup[]"}},0,0],[[],"GetOperationErrors",{R_:{operationErrors:"PDM.OperationErrors"}},0,0],[[],"GetOperationFailures",{R_:{operationFailures:"ErrorList"}},0,0],[["numberOfLogicalObjects"],"GetLogicalObjects",{R_:{logicalObjects:"PDM.LogicalObject[]"}},0,0]],[]];
SPLM.PDM.AttributeGroupReviseBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.AttributeGroupReviseBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.AttributeGroupReviseBuilder.SaveAsActionType = Object.freeze({
    "NewRevision" : "NewRevision", "NewAttributeGroup" : "NewAttributeGroup"});

export default SPLM;